

import * as React from 'react';
import cn from 'classnames';
import '../../../../styles/modules/utility.less';
import styles from './spinner.module.css';

const FullPageLoadingSpinner = () => (
  <div className={cn(styles.spinner)}>
    <div className={cn(styles.image)} />
  </div>
);

export default FullPageLoadingSpinner;
